import * as React from 'react'

export const IconUmbrella = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 12a1 1 0 0 1 1 1v6a3 3 0 1 1-6 0v-1a1 1 0 1 1 2 0v1a1 1 0 1 0 2 0v-6a1 1 0 0 1 1-1ZM12 1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1Z'
      fill='#EEE6EF'
    />
    <path
      d='M12 3c-5.186 0-9.45 3.947-9.95 9.001-.055.55.398.999.95.999h18c.552 0 1.005-.449.95-.999C21.45 6.947 17.187 3 12 3Z'
      fill='currentColor'
    />
  </svg>
)
